import { render, staticRenderFns } from "./GameExceptions.vue?vue&type=template&id=59caf40a&scoped=true&"
import script from "./GameExceptions.vue?vue&type=script&lang=ts&"
export * from "./GameExceptions.vue?vue&type=script&lang=ts&"
import style0 from "./GameExceptions.vue?vue&type=style&index=0&id=59caf40a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59caf40a",
  null
  
)

export default component.exports